import { Icon } from 'components';
import { Grid, Typography } from 'e100-react-components';
import React from 'react';

const LocationItem = ({ kind, label }: LocationItemProps) => {
  if (!label) {
    return null;
  }
  return (
    <Grid container>
      <Grid item xs={1}>
        <Icon kind={kind} />
      </Grid>
      <Grid item xs={11}>
        <Typography variant="body1" noWrap>
          {label}
        </Typography>
      </Grid>
    </Grid>
  );
};

interface LocationItemProps {
  kind: string;
  label: string;
}

export const RouteInfo = ({ from, to, classes }: RouteInfoProps) => {
  return (
    <Grid
      container
      classes={{
        root: classes?.container?.root || '',
      }}
    >
      <Grid item xs={12}>
        <LocationItem kind="routePointForm" label={from} />
      </Grid>
      <Grid item xs={12}>
        <LocationItem kind="routePointTo" label={to} />
      </Grid>
    </Grid>
  );
};

interface RouteInfoProps {
  from: string;
  to: string;
  classes?: {
    container?: {
      root?: string;
    };
  };
}
